const FilterServerConstantes = {
  MENU: {
    filtros: "menu-filtros",
    opciones: "menu-opciones",
    opcionesEditar: "menu-opciones-editar",
  },
};

export default FilterServerConstantes;
